export default {
      id: "bluetooth-usage",
      viewBox: "0 0 52 30",
      url: __webpack_public_path__ + "img/icons.svg#bluetooth",
      toString: function () {
        return this.url;
      }
    }